// 环境配置——dev 时 Vite 把 /api 反代到 127.0.0.1:8888；prod 由 Caddy 反代。
// 所以两侧都用相对路径 '/api'，无需切环境变量。
// 鉴权统一走 JWT（Authorization: Bearer），不再需要 X-API-Key 这类共享密钥。

const isDev = import.meta.env.DEV

export const settings = {
    API_BASE: '', // 相对路径，dev/prod 都靠反代
    debug: isDev,
}
